var render = function () {
  var _vm$state, _vm$state$data, _vm$state2, _vm$state2$data, _vm$hashTag, _vm$state$data$custom;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container safe-padding-bottom"
  }, [_vm.state.loading ? _c('m-loading', {
    staticClass: "loading"
  }) : _vm.state.error ? _c('CoEmpty', {
    staticClass: "empty",
    on: {
      "click-btn": _vm.init
    }
  }) : [_c('DetailHeader', {
    attrs: {
      "call-app-option": _vm.callAppOption
    }
  }), _c('ImageSwiper', {
    attrs: {
      "images": (_vm$state = _vm.state) === null || _vm$state === void 0 ? void 0 : (_vm$state$data = _vm$state.data) === null || _vm$state$data === void 0 ? void 0 : _vm$state$data.dynamicImages
    }
  }), _c('div', {
    staticClass: "content_wrapper"
  }, [_vm.state.data.title ? _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.state.data.title) + " ")]) : _vm._e(), _c('RichContent', {
    attrs: {
      "content": (_vm$state2 = _vm.state) === null || _vm$state2 === void 0 ? void 0 : (_vm$state2$data = _vm$state2.data) === null || _vm$state2$data === void 0 ? void 0 : _vm$state2$data.description
    }
  }), ((_vm$hashTag = _vm.hashTag) === null || _vm$hashTag === void 0 ? void 0 : _vm$hashTag.length) ? _c('div', {
    staticClass: "hash_tag_wrapper"
  }, _vm._l(_vm.hashTag, function (item, idx) {
    return _c('span', {
      key: idx,
      staticClass: "hash_tag"
    }, [_vm._v(" " + _vm._s("#".concat(item.tagName)) + " ")]);
  }), 0) : _vm._e(), ((_vm$state$data$custom = _vm.state.data.customLocation) === null || _vm$state$data$custom === void 0 ? void 0 : _vm$state$data$custom.city) ? _c('div', {
    staticClass: "location_wrapper"
  }, [_c('div', {
    staticClass: "location"
  }, [_c('img', {
    staticClass: "location_icon",
    attrs: {
      "src": _vm.locationIcon,
      "alt": "location"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.state.data.customLocation.city))])])]) : _vm._e(), _vm.state.data.lastUpdateTime ? _c('div', {
    staticClass: "time"
  }, [_vm._v(" " + _vm._s(_vm.getTimeAgo(_vm.state.data.lastUpdateTime)) + " ")]) : _vm._e(), _c('ActionBar', {
    attrs: {
      "interact-info": _vm.state.data.interactInfo,
      "call-app-option": _vm.callAppOption
    }
  })], 1), _c('m-button', {
    staticClass: "fixed_btn safe-fixed-bottom",
    on: {
      "click": _vm.handleClickBtn
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.topickTag,
      "alt": "topick"
    }
  }), _c('span', {
    staticClass: "text"
  }, [_c('k18n', [_vm._v("Open in Topick")])], 1)])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }